import React from "react";

interface FormLabelProps {
  children: React.ReactNode;
  htmlFor?: string;
  required?: boolean;
  className?: string;
}

const FormLabel: React.FC<FormLabelProps> = ({
  children,
  htmlFor,
  required = false,
  className = "",
}) => {
  return (
    <label
      htmlFor={htmlFor}
      className={`block mb-2 font-poppins text-xs font-semibold md:font-normal leading-[12px] text-darkBlack ${className}`}
    >
      {children}
      {required && <span className="text-red-500">*</span>}
    </label>
  );
};

export default FormLabel;
